var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHlaB155(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 128.237,
    height: 79.634,
    viewBox: "0 0 128.237 79.634",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34355",
    "data-name": "Group 34355",
    transform: "translate(-341.895 -868.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_32451",
    "data-name": "Group 32451",
    transform: "translate(344 870)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x1: 31.703,
    transform: "translate(49.734 6.715)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    x1: 28.977,
    transform: "translate(51.369 17.652)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x1: 21.344,
    transform: "translate(55.731 28.589)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x2: 31.703,
    transform: "translate(41.809 72.734)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x2: 27.342,
    transform: "translate(42.9 61.797)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    x2: 21.344,
    transform: "translate(46.171 50.86)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26420",
    "data-name": "Path 26420",
    d: "M7236.54,2554.914c14.428-3.86,19.813-12.357,19.813-33.01",
    transform: "translate(-7174.917 -2515.189)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26421",
    "data-name": "Path 26421",
    d: "M7207.715,2602.937c-14.428,3.86-19.814,12.357-19.814,33.01",
    transform: "translate(-7146.091 -2563.212)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26422",
    "data-name": "Path 26422",
    d: "M7269.712,2642.387c0-15.489-3.029-23.6-10.631-28.583",
    transform: "translate(-7188.275 -2569.652)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26423",
    "data-name": "Path 26423",
    d: "M7187.9,2521.9c0,15.49,3.03,23.6,10.632,28.583",
    transform: "translate(-7146.091 -2515.189)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_500",
    "data-name": "Ellipse 500",
    cx: 8.941,
    cy: 8.941,
    r: 8.941,
    transform: "translate(89.955 0)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    x1: 16.675,
    y2: 13.659,
    transform: "translate(88.821 43.298)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26424",
    "data-name": "Path 26424",
    d: "M7306.534,2549.441l-1.937,17.388-10.666,9.26",
    transform: "translate(-7208.929 -2531.509)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26425",
    "data-name": "Path 26425",
    d: "M7323.251,2519.293a3.29,3.29,0,1,0,3.29,3.29",
    transform: "translate(-7224.355 -2513.642)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_32447",
    "data-name": "Group 32447",
    transform: "translate(100.482 25.331)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_501",
    "data-name": "Ellipse 501",
    cx: 8.941,
    cy: 8.941,
    r: 8.941,
    transform: "matrix(0.383, -0.924, 0.924, 0.383, 0, 16.52)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26426",
    "data-name": "Path 26426",
    d: "M7355.819,2588.2a3.29,3.29,0,1,0,3.29,3.29",
    transform: "translate(-7344.138 -2579.811)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32448",
    "data-name": "Group 32448",
    transform: "translate(98.269 58.252)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_502",
    "data-name": "Ellipse 502",
    cx: 8.941,
    cy: 8.941,
    r: 8.941,
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26427",
    "data-name": "Path 26427",
    d: "M7343.661,2662.29a3.29,3.29,0,1,0,3.29,3.29",
    transform: "translate(-7334.72 -2656.639)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32449",
    "data-name": "Group 32449",
    transform: "translate(6.768 58.252)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_503",
    "data-name": "Ellipse 503",
    cx: 8.941,
    cy: 8.941,
    r: 8.941,
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26428",
    "data-name": "Path 26428",
    d: "M7119.043,2662.29a3.29,3.29,0,1,0,3.29,3.29",
    transform: "translate(-7110.103 -2656.639)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_32450",
    "data-name": "Group 32450",
    transform: "translate(0 26.256)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_504",
    "data-name": "Ellipse 504",
    cx: 8.941,
    cy: 8.941,
    r: 8.941,
    transform: "translate(0 4.108) rotate(-13.283)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26429",
    "data-name": "Path 26429",
    d: "M7106.885,2588.2a3.29,3.29,0,1,0,3.29,3.29",
    transform: "translate(-7096.128 -2580.736)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_505",
    "data-name": "Ellipse 505",
    cx: 8.941,
    cy: 8.941,
    r: 8.941,
    transform: "translate(15.082 0)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26430",
    "data-name": "Path 26430",
    d: "M7139.454,2519.293a3.29,3.29,0,1,0,3.29,3.29",
    transform: "translate(-7115.43 -2513.642)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x1: 8.708,
    transform: "translate(89.144 67.193)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x2: 16.675,
    y2: 13.659,
    transform: "translate(17.423 43.298)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26431",
    "data-name": "Path 26431",
    d: "M7146.616,2551.817l2.259,16.42,10.666,9.26",
    transform: "translate(-7121.625 -2532.917)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x2: 8.708,
    transform: "translate(25.067 67.193)",
    fill: "none",
    stroke: "#fb7982",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHlaB155);
export default __webpack_public_path__ + "static/media/hla-b-15-5.4294f53240a516f20e8c19fc7c5a7399.svg";
export { ForwardRef as ReactComponent };